import Email from './components/Email'
import Share from './components/Share'

import apConfig from "@config/340.json"
if (apConfig.actionpage && apConfig.template && apConfig.template == true) { apConfig.actionpage = null; }
export const config = apConfig
export const steps = {Email,Share}

export const portals = {}

